<script lang="ts">
    import { language } from "src/lang";
    import { DBState } from "src/ts/stores.svelte";
    import Check from "src/lib/UI/GUI/CheckInput.svelte";
    import Help from "src/lib/Others/Help.svelte";
    import type { botPreset } from "src/ts/storage/database.svelte";

    let { getPreset }: { getPreset?: () => botPreset | null | undefined } = $props();
    let settings = $derived(getPreset?.() ?? DBState.db);
</script>

<div class="flex items-center">
    <Check name={language.search} check={(settings.modelTools ?? []).includes('search')} onChange={() => {
        if ((settings.modelTools ?? []).includes('search')) {
            settings.modelTools = (settings.modelTools ?? []).filter((tool) => tool !== 'search');
        } else {
            settings.modelTools = [...(settings.modelTools ?? []), 'search'];
        }
    }} />
    <Help key="searchTool"/>
</div>
